// extracted by mini-css-extract-plugin
module.exports = {"isDefault":"Star_isDefault__3o9Vx","isActive":"Star_isActive__zBWTv","willBeActive":"Star_willBeActive__UdUu3","isDisabled":"Star_isDisabled__3W-gm"};